import { render } from "./rough_report.vue?vue&type=template&id=2d68c753"
import script from "./rough_report.vue?vue&type=script&lang=js"
export * from "./rough_report.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__